var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full -mt-20"},[_c('div',{staticClass:"flex items-center justify-center ml-36 pb-2"},[_c('img',{attrs:{"src":_vm.companyUrl}})])])}
var staticRenderFns = []

export { render, staticRenderFns }